import { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";

import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { FormLabel, FormSelect } from "react-bootstrap";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import FormGroup from "react-bootstrap/FormGroup";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import SurveyUtils from "../../../utils/SurveyUtils";
import FundingAreaContainer from "../fundingArea/FundingAreaContainer";

class TemplateActivation extends Component {
  constructor(props) {
    super(props);
    this._resetDialog = this._resetDialog.bind(this);
    this._startActivation = this._startActivation.bind(this);
    this._activate = this._activate.bind(this);
  }

  render() {
    const { show, template, step, numberOfPossibleProjects, currentYear, activationActive, intl, selectedProgram, selectedProgramInstance } = this.props;

    const year = new Date().getFullYear();
    const isSemesterTypeProgram = SurveyUtils.isSemesterTypeProgram(selectedProgram?.name);
    return (
      <Modal show={show} size="lg" enforceFocus autoFocus>
        <ModalHeader>
          <Modal.Title>
            <FormattedMessage id="template.activation.title" />
          </Modal.Title>
        </ModalHeader>
        <Modal.Body>
          {step ? (
            <>
              <FormGroup  className="mb-3">
                <FormLabel>
                  <FormattedMessage id="survey.settings.create.reports" />
                </FormLabel>
                <FundingAreaContainer preventProjectChoice target="templateActivation" programInstanceRequired={isSemesterTypeProgram}/>
              </FormGroup>
              <FormGroup  className="mb-3">
                <FormLabel>
                  <FormattedMessage id="survey.settings.choose.period" />
                </FormLabel>
                <FormSelect
                  name="selectedPredefinedSurveyPeriod"
                  value={currentYear}
                  onChange={(event) => {
                    this._setPeriod(event.target.value);
                  }}
                >
                  {[year - 1, year, year + 1].map((i) => (
                    <option key={i} value={i}>{SurveyUtils.getReportPeriodLabel(intl, selectedProgram?.name, i)}</option>
                  ))}
                </FormSelect>
              </FormGroup>
            </>
          ) : (
            <>
              <FormattedMessage
                id="survey.settings.activate.survey.info"
                values={{ numProjects: numberOfPossibleProjects }}
              />
              <Alert variant="warning" className="mt-4">
                <FontAwesomeIcon icon={faExclamationTriangle} />{" "}
                <FormattedMessage id="survey.settings.activate.survey.warning" />
              </Alert>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this._resetDialog}>
            <FormattedMessage id="app.common.Cancel" />
          </Button>
          <Button
            disabled={activationActive || (isSemesterTypeProgram && !selectedProgramInstance)}
            onClick={step && !isSemesterTypeProgram ? () => this._startActivation(template) : () => this._activate(template, isSemesterTypeProgram)}
          >
            <FormattedMessage id="app.common.activate" />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  _setPeriod(year) {
    let intYear = parseInt(year, 10);
    let begin = new Date(Date.UTC(intYear, 0, 1, 0, 0, 0, 0)).getTime();
    let end = new Date(Date.UTC(intYear, 11, 31, 23, 59, 59, 999)).getTime();

    this.props.actions.setPeriod(begin, end, year);
  }

  _startActivation(template) {
    this.props.actions.validateActivation(template);
  }

  _activate(template, isSemesterTypeProgram) {
    this.props.actions.activation(template, this.props.externalActions.close, isSemesterTypeProgram);
  }

  _resetDialog() {
    this.props.actions.resetDialog(this.props.externalActions.close);
  }
}

TemplateActivation.propTypes = {
  show: PropTypes.bool,
  template: PropTypes.object,
  externalActions: PropTypes.object,
  actions: PropTypes.object,
  step: PropTypes.bool,
  numberOfPossibleProjects: PropTypes.number,
  currentYear: PropTypes.string,
  activationActive: PropTypes.bool,
  selectedProgram: PropTypes.object,
  selectedProgramInstance: PropTypes.object,
};

export default injectIntl(TemplateActivation);
